(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      root.querySelectorAll('[data-maison-carousel]').forEach(function (el) {
        if (el.dataset.ready) return;
        el.dataset.ready = 'true';
        var track = el.querySelector('.maison-carousel__track');
        var prev = el.querySelector('[data-dir="-1"]');
        var next = el.querySelector('[data-dir="1"]');
        if (!track) return;

        var bar = el.querySelector('[data-mc-bar]');
        function update() {
          var max = track.scrollWidth - track.clientWidth;
          var ratio = track.scrollWidth ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
          if (bar) {
            bar.style.width = (ratio * 100) + '%';
            bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%)';
          }
          el.classList.toggle('is-static', max <= 2);
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
        }

        [prev, next].forEach(function (btn) {
          if (!btn) return;
          btn.addEventListener('click', function () {
            if (window.maisonSlide) return window.maisonSlide(track, '.maison-carousel__slide', Number(btn.dataset.dir), 1);
            var slide = track.querySelector('.maison-carousel__slide');
            var step = slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
            track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
          });
        });

        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { ticking = false; update(); });
        }, { passive: true });
        window.addEventListener('resize', update);
        // Las flechas y la barra se calculan cuando la página terminó de cargar (sin forzar el diseño mientras carga)
        if (document.readyState === 'complete') requestAnimationFrame(update); else window.addEventListener('load', function () { requestAnimationFrame(update); }, { once: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setup(document); });
    } else {
      setup(document);
    }
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
